export default __webpack_public_path__ + "8989917a01012262dab7ff5dcaa2c1c0.png";